import serviceParcela from '@/services/GsEncuesta/parcela'

export default {
  PARCELA_FIND_ALL(_, params) {
    return new Promise((resolve, reject) => {
      serviceParcela.findAll(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  PARCELA_FIND(_, params) {
    return new Promise((resolve, reject) => {
      serviceParcela.find(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  PARCELA_CREATE(_, params) {
    return new Promise((resolve, reject) => {
      serviceParcela.create(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  PARCELA_CREATE_ALL(_, params) {
    return new Promise((resolve, reject) => {
      serviceParcela.createAll(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  PARCELA_UPDATE(_, params) {
    return new Promise((resolve, reject) => {
      serviceParcela.update(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  PARCELA_DELETE(_, params) {
    return new Promise((resolve, reject) => {
      serviceParcela.delete(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
}
